import { DashboardWidget } from "../../../api/types/Overview";

// deprecated
export enum EWidgetTypes {
  SAFETY_EVENTS = "SAFETY_EVENTS",
  FLEET_FUEL_SUMMARY = "FLEET_FUEL_SUMMARY",
  ASSET_EVENTS = "ASSET_EVENTS",
  MAINTENANCE_OVERDUE = "MAINTENANCE_OVERDUE",
  ASSET_STATUS_REPORT = "ASSET_STATUS_REPORT",
}

export type TDashboardColumn = {
  id: string;
  colWidgets: DashboardWidget[];
};

export type TDashboardColumns = {
  [col: string]: TDashboardColumn;
};

export enum EWidgetChartTypes {
  PIE = "PIE",
  DOUGHNUT = "DOUGHNUT",
  VERTICAL_BAR_GRAPH = "VERTICAL_BAR_GRAPH",
  HORIZONTAL_BAR_GRAPH = "HORIZONTAL_BAR_GRAPH",
  STACKED_BAR_GRAPH = "STACKED_BAR_GRAPH",
  LINE_GRAPH = "LINE_GRAPH",
}
